var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { attrs: { "data-vv-scope": "invoice" } },
    [
      _c("h3", { staticClass: "text-primary" }, [
        _vm._v("Emisión de Factura Electrónica")
      ]),
      _c("TableReceiptDetail", {
        attrs: {
          columns: _vm.columns,
          mappedReceiptDataTable: _vm.mappedReceiptDataTable
        }
      }),
      _c("h5", [_vm._v(" Información del receptor ")]),
      _c("b-card", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-6 mt-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Rut receptor" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.invoice.iut,
                      callback: function($$v) {
                        _vm.$set(_vm.invoice, "iut", $$v)
                      },
                      expression: "invoice.iut"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Razón Social" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.invoice.businessName,
                      callback: function($$v) {
                        _vm.$set(_vm.invoice, "businessName", $$v)
                      },
                      expression: "invoice.businessName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Giro" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.invoice.commercialName,
                      callback: function($$v) {
                        _vm.$set(_vm.invoice, "commercialName", $$v)
                      },
                      expression: "invoice.commercialName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Dirección" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.invoice.address,
                      callback: function($$v) {
                        _vm.$set(_vm.invoice, "address", $$v)
                      },
                      expression: "invoice.address"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Ciudad/provincia" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.invoice.city,
                      callback: function($$v) {
                        _vm.$set(_vm.invoice, "city", $$v)
                      },
                      expression: "invoice.city"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Comuna" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.invoice.commune,
                      callback: function($$v) {
                        _vm.$set(_vm.invoice, "commune", $$v)
                      },
                      expression: "invoice.commune"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Teléfono" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.invoice.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.invoice, "phone", $$v)
                      },
                      expression: "invoice.phone"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Correo" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.invoice.email,
                      callback: function($$v) {
                        _vm.$set(_vm.invoice, "email", $$v)
                      },
                      expression: "invoice.email"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Fecha de emisión" } },
                [
                  _c("b-form-datepicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      name: "date",
                      "data-vv-as": "fecha de emisión",
                      state: _vm.errors.has("invoice.date") ? false : null,
                      "label-no-date-selected": "No se ha seleccionado fecha",
                      "label-help":
                        "Puede usar las flechas del teclado y espacio"
                    },
                    model: {
                      value: _vm.invoice.issueDate,
                      callback: function($$v) {
                        _vm.$set(_vm.invoice, "issueDate", $$v)
                      },
                      expression: "invoice.issueDate"
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" " + _vm._s(_vm.errors.first("invoice.date")) + " ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 text-right" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "ripple",
                      rawName: "v-ripple.400",
                      value: "rgba(113, 102, 240, 0.15)",
                      expression: "'rgba(113, 102, 240, 0.15)'",
                      modifiers: { "400": true }
                    }
                  ],
                  staticClass: "btn-icon",
                  attrs: { variant: "primary" }
                },
                [
                  _c("vs-icon", { attrs: { icon: "search" } }),
                  _vm._v(" Vista previa ")
                ],
                1
              ),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "ripple",
                      rawName: "v-ripple.400",
                      value: "rgba(113, 102, 240, 0.15)",
                      expression: "'rgba(113, 102, 240, 0.15)'",
                      modifiers: { "400": true }
                    }
                  ],
                  staticClass: "ml-4 btn-icon",
                  attrs: { variant: "success" },
                  on: { click: _vm.submitInvoice }
                },
                [
                  _c("vs-icon", { attrs: { icon: "save" } }),
                  _vm._v(" Emitir ")
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }